'use client';
import { useCourses } from '@/hooks/useCourses';
import CourseHeader from '@/modules/khoa-hoc/components/CourseHeader';
import CourseDetail from '@/modules/khoa-hoc/components/CourseDetail';
import TeacherDetail from '@/modules/khoa-hoc/components/TeacherDetail';
import { Course } from '@/types/data';
import React, { useEffect, useState } from 'react';
import CourseMetadata from '@/components/common/CourseMetadata';

interface KhoaHocPageProps {
  params: {
    slug_url: string;
  };
}

const KhoaHocPage: React.FC<KhoaHocPageProps> = ({ params }) => {
  const { slug_url } = params;

  const { loading, error, getCourseBySlug } = useCourses();
  const [course, setCourse] = useState<Course | undefined>(undefined);

  // Scroll lên đầu trang mỗi khi vào trang chi tiết hoặc đổi slug
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [slug_url]);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        const course = await fetch(`/khoa-hoc/api?slug=${slug_url}`).then((res) => res.json());
        setCourse(course);
      } catch (error) {
        throw new Error(error instanceof Error ? error.message : 'Failed to fetch course');
      }
    };
    fetchCourse();
  }, [slug_url]);

  return (
    <>
      <CourseMetadata data-component-id="src/app/khoa-hoc/[slug_url]/page.tsx:43:6" data-component-path="src/app/khoa-hoc/[slug_url]/page.tsx" data-component-line="43" data-component-end-line="43" data-component-file="page.tsx" data-component-name="CourseMetadata" data-component-content="%7B%22elementName%22%3A%22CourseMetadata%22%7D" course={course || null} />
      {course && (
        <>
          {/* Course header */}
          <CourseHeader data-component-id="src/app/khoa-hoc/[slug_url]/page.tsx:47:10" data-component-path="src/app/khoa-hoc/[slug_url]/page.tsx" data-component-line="47" data-component-end-line="47" data-component-file="page.tsx" data-component-name="CourseHeader" data-component-content="%7B%22elementName%22%3A%22CourseHeader%22%7D" course={course} />

          {/* Course detail */}
          <CourseDetail data-component-id="src/app/khoa-hoc/[slug_url]/page.tsx:50:10" data-component-path="src/app/khoa-hoc/[slug_url]/page.tsx" data-component-line="50" data-component-end-line="50" data-component-file="page.tsx" data-component-name="CourseDetail" data-component-content="%7B%22elementName%22%3A%22CourseDetail%22%7D" course={course} />

          {/* Teacher detail */}
          {course.teacher && <TeacherDetail data-component-id="src/app/khoa-hoc/[slug_url]/page.tsx:53:29" data-component-path="src/app/khoa-hoc/[slug_url]/page.tsx" data-component-line="53" data-component-end-line="53" data-component-file="page.tsx" data-component-name="TeacherDetail" data-component-content="%7B%22elementName%22%3A%22TeacherDetail%22%7D" teacher={course.teacher} />}
        </>
      )}
    </>
  );
};

export default KhoaHocPage;
